<template>
    <div class="card py-3 px-5 has-background-secondary-lighted mb-5">
        <div class="is-flex is-align-items-center">
            <div>
                <img class="mr-5" style="width:76px" :src="siiLogo" />
            </div>
            <div class="pr-5">
                <p>
                    <span class="has-text-weight-semibold">
                        Automatiza tus documentos
                    </span>
                    del Servicio de Impuestos Internos a través de
                    <FintocLogo class="is-relative" style="width:60px;vertical-align:bottom; top:1px" />
                </p>
                <p class="mb-2">
                    En esta primera etapa podrás obtener
                    <span class="has-text-weight-semibold">
                        Factura electrónica</span>,
                    <span class="has-text-weight-semibold">
                        Factura no afecta o exenta electrónica
                    </span>
                    y
                    <span class="has-text-weight-semibold">
                        Boletas de Honorarios
                    </span>
                    de tu negocio.
                </p>
                <p v-if="isWaiting">
                    Deseas conocer más en detalle esté proceso
                    <a class="has-text-secondary is-underlined" type="is-text" v-on:click.prevent="toggleCollapse">
                        <span>Infórmate más aquí</span>
                        <i class="material-icons is-size-6 is-relative" style="top:3px">
                            {{
                                collapseIsOpen
                                    ? "keyboard_arrow_up"
                                    : "keyboard_arrow_down"
                            }}
                        </i>
                    </a>
                </p>
            </div>
            <div class="ml-auto">
                <img v-if="isWaiting" style="width:40px" class="has-text-secondary" :src="clock" />
                <b-button v-else rounded type="is-secondary" @click="toggleCollapse"
                    :icon-right="collapseIsOpen ? 'angle-up' : 'angle-down'">
                    ¡Comienza ya!
                </b-button>
            </div>
        </div>
        <b-collapse :open="collapseIsOpen" animation="slide">
            <template>
                <div>
                    <div class="horizontal-separator my-4"></div>
                    <p class="has-text-secondary has-text-weight-semibold mb-4">
                        Deberás tener en consideración los siguientes puntos:
                    </p>
                    <ul style="list-style:disc" class="pl-4">
                        <li class="mb-3">
                            Al conectarte traeremos la información desde tu
                            cuenta del Servicio de Impuestos Internos (SII) a
                            partir del
                            <span class="has-text-weight-semibold">01 de enero del 2020.</span>
                        </li>
                        <li class="mb-3">
                            Los
                            <span class="has-text-weight-semibold">tiempos de carga de estos documentos
                                automáticos en CFOremoto pueden variar</span>
                            dependiendo de la cantidad de documentos que poseas.
                            (Te recomendamos esperar aproximadamente 24hrs para
                            estar seguros de que todos tus documentos llegaron a
                            nuestra plataforma).
                        </li>
                        <li class="mb-3">
                            En el proceso de conexión
                            <span class="has-text-weight-semibold">tus documentos asociados al SII ingresados
                                manualmente dejarán de estar visibles
                            </span>
                            para esperar los documentos legítimos.
                        </li>
                        <li class="mb-3">
                            Durante esa espera de ingreso de documentos
                            automatizados los valores del gráfico de proyección
                            o montos por pagar o cobrar se verán afectados. Una
                            vez llegado los documentos podrás ver los valores
                            restablecidos
                        </li>
                        <li class="mb-3">
                            Una vez llegados los documentos automáticos quedarán
                            en el estado
                            <span class="has-text-weight-semibold">PAGADO</span>
                            todos aquellos que su fecha de vencimiento sea mayor
                            a 15 días. Si por alguna razón esos documentos no
                            están pagados podrás editarlo en la sección ESTADO
                            de cada fila del documento."
                        </li>
                        <li class="mb-3">
                            Al tener los documentos automatizados desde el SII
                            <span class="has-text-weight-semibold">no podrás subir de forma manual ese mismo tipo
                                de obligación. Ni tampoco podrás borrar o editar
                                montos o número</span>
                            de los documentos que provienen directo del SII.
                        </li>
                        <li class="mb-3">
                            Poseer información real y directa desde el SII te
                            permitirá acceder a diferentes opciones de
                            financiamiento en caso de necesitarlo.
                        </li>
                    </ul>
                    <div v-if="!isWaiting" class="has-text-centered mt-6 mb-4">
                        <b-checkbox v-model="hasReadDisclaimer" type="is-secondary">
                            He leído y comprendo los puntos correspondientes a
                            la conexión
                        </b-checkbox>
                    </div>
                    <div v-if="!isWaiting" class="has-text-centered mb-5">
                        <b-button rounded :loading="widgetIsLoading" :disabled="!hasReadDisclaimer" type="is-secondary"
                            @click="onConnectSii">
                            ¡Conéctate!
                        </b-button>
                    </div>
                </div>
            </template>
        </b-collapse>
    </div>
</template>

<script>
import clock from "@/assets/images/clock.svg";
import siiLogo from "@/assets/images/sii.svg";
import FintocLogo from "@/components/svg/FintocLogo.vue";
export default {
    name: "SiiConnect",
    components: {
        FintocLogo,
    },
    props: {
        widgetIsLoading: {
            type: Boolean,
            default: false,
        },
        isWaiting: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            siiLogo: siiLogo,
            clock: clock,
            collapseIsOpen: false,
            hasReadDisclaimer: false,
        };
    },
    methods: {
        toggleCollapse() {
            this.collapseIsOpen = !this.collapseIsOpen;
        },
        onConnectSii() {
            this.collapseIsOpen = false;
            this.$emit("onConnectSii");
        },
    },
};
</script>
